import { useLoaderData } from "react-router";

import { processRequest } from "@api/config";
import { payoutSettingsAPI } from "@api/payoutSettings";

import { TSessionData } from "@storage/session/types";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";
import { STALE_INFINITY } from "@configs/constants";

export const usePaymentMethodsStateQuery = () => {
	const { currentAccount } = useLoaderData<TSessionData>();

	return useAuthQuery({
		queryKey: [QUERY_KEYS.PAYMENT_METHODS_STATE],
		queryFn: async () => {
			if (currentAccount.isIndividual) {
				const data = await processRequest({
					prefix: API_PREFIXES.GET_PAYMENT_METHODS_STATE,
					request: (token) => payoutSettingsAPI.getPaymentMethodsStateAsync({ token }),
				});

				return data;
			}

			return Promise.reject();
		},
		staleTime: STALE_INFINITY,
		retry: false,
		refetchOnWindowFocus: false,
	});
};
